<app-card [title]="board.nombre" [favorite]="board.favorito" [isActive]="board.activo" (favoriteEvent)="onFavorite($event)">
    <p *ngIf="board.descripcion" class="description">{{ board.descripcion }}</p>
    <div class="options dropdown-center">
        <button type="button" class="btn" class="btn-generate" (click)="loadEmbeddedBoard()"><p *ngIf="board.activo">ver</p></button>
        <button *ngIf="canInactivate" class="ellipsis" data-bs-toggle="dropdown" aria-expanded="false">
            <fa-icon class="icon" [icon]="faEllipsis"></fa-icon>
        </button>
        <ul class="dropdown-menu">
            <li><button class="dropdown-item" (click)="deleteBoard(board)" [disabled]="!globalService.canUserEdit()">Eliminar</button></li>
            <li><button *ngIf="board.activo" class="dropdown-item" (click)="disableReport()" [disabled]="!globalService.canUserEdit()">Deshabilitar</button></li>
            <li><button *ngIf="!board.activo" class="dropdown-item" (click)="disableReport()" [disabled]="!globalService.canUserEdit()">Habilitar</button></li>
        </ul>
    </div>
</app-card>
